module.exports = __webpack_public_path__ + "static/media/cv-joints-and-cv-axles-red.12ad0a1f.svg";